import "./App.css";
import { ConfigProvider, message } from "antd";
import RootRoute from "./routes/RootRoute";

function App() {
  message.config({
    duration: 3,
  });

  return (
    <ConfigProvider>
      <RootRoute />
    </ConfigProvider>
  );
}

export default App;
